// extracted by mini-css-extract-plugin
module.exports = {"allItemsSelected":"MultiSelectHeader_allItemsSelected__3GttE"};